var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mb-0 mr-25"},[_c('h6',{staticClass:"font-weight-bolder mb-0"},[_vm._v(" IDR "+_vm._s(_vm.convertNumber(_vm.$store.state['app-ecommerce'].priceTotal))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }